import { css } from 'styled-components';
import { prem } from 'styles/helpers/spacing';
import { BODY } from 'styles/helpers/typography';

/**
 * Shared look of the numbered installation steps
 * (used by both the computer and the smartphone tutorials).
 */
const installStepsStyles = css`
  .steps {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: ${prem(16)};
    max-width: ${prem(500)};
    margin: 0 auto;
    padding: 0;
    list-style: none;
  }

  .step {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${prem(20)};
    border-radius: ${prem(24)};
    color: white;
    background: var(--comcolors-modal-background);
    text-align: center;
  }

  .step-number {
    ${BODY.small}
    display: inline-block;
    padding: ${prem(4)} ${prem(14)};
    margin-bottom: ${prem(10)};
    border-radius: ${prem(20)};
    font-weight: bold;
    text-transform: uppercase;
    color: var(--comcolors-modal-background);
    background: white;
  }

  .step-hint {
    ${BODY.medium}
    margin: 0 0 ${prem(14)};
    color: white;
    line-height: 1.4;
    text-align: center;
  }
`;

export { installStepsStyles };
